import { render, staticRenderFns } from "./ArticleList.component.vue?vue&type=template&id=1598dfab&scoped=true"
import script from "./ArticleList.component.vue?vue&type=script&lang=ts"
export * from "./ArticleList.component.vue?vue&type=script&lang=ts"
import style0 from "./ArticleList.component.vue?vue&type=style&index=0&id=1598dfab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1598dfab",
  null
  
)

export default component.exports